const finitePriority = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : Number.MAX_SAFE_INTEGER;
};

const localizedName = (branch = {}, language = "english") => {
  const arabic = language === "arabic";
  return `${
    (arabic && (branch.name_ar || branch.arabic_name || branch.title_ar)) ||
    branch.name ||
    branch.title ||
    branch.branch_name ||
    ""
  }`;
};

const compareIds = (left, right) => {
  const leftNumber = Number(left);
  const rightNumber = Number(right);
  if (Number.isFinite(leftNumber) && Number.isFinite(rightNumber))
    return leftNumber - rightNumber;
  return `${left ?? ""}`.localeCompare(`${right ?? ""}`, undefined, {
    numeric: true,
  });
};

export const sortContextBranches = (branches = [], language = "english") =>
  [...branches].sort((left, right) => {
    const priorityDifference =
      finitePriority(
        left.branch_sort_order ??
          left.priority ??
          left.storefront_priority ??
          left.sort_order,
      ) -
      finitePriority(
        right.branch_sort_order ??
          right.priority ??
          right.storefront_priority ??
          right.sort_order,
      );
    if (priorityDifference) return priorityDifference;
    const nameDifference = localizedName(left, language).localeCompare(
      localizedName(right, language),
      language === "arabic" ? "ar" : "en",
      { sensitivity: "base", numeric: true },
    );
    return nameDifference || compareIds(left.id, right.id);
  });
